export default __webpack_public_path__ + "static/bncff-web-site-6-mobile-3bc69f89bc7ecb803145f6592b01acb8.jpg";